import { render } from "./ComponentGridComponent.vue?vue&type=template&id=0c9485da"
import script from "./ComponentGridComponent.vue?vue&type=script&lang=js"
export * from "./ComponentGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__